import { DataProxy } from '@apollo/client';

import { FullAnswerFragment, GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables } from '../gen/types';
import { GET_QUESTION_DETAILS_QUERY } from '../queries/GetQuestionDetails';

export function prependAnswerToQuestionDetailsCache(
  proxy: DataProxy,
  {
    questionId,
    answer,
  }: {
    questionId: string;
    answer: FullAnswerFragment;
  }
): void {
  const queryKey = {
    query: GET_QUESTION_DETAILS_QUERY,
    variables: {
      questionId,
    },
  };

  try {
    const existingData = proxy.readQuery<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>(queryKey);

    if (existingData?.loggedIn?.questionById != null) {
      const newAnswers = [
        answer,
        ...(existingData.loggedIn?.questionById?.answers.filter((item) => item.id !== answer.id) || []),
      ];
      proxy.writeQuery<GetQuestionDetailsQuery, GetQuestionDetailsQueryVariables>({
        ...queryKey,
        data: {
          ...existingData,
          loggedIn: {
            ...existingData.loggedIn,
            questionById: {
              ...existingData.loggedIn?.questionById,
              answers: newAnswers,
            },
          },
        },
      });
    }
  } catch (_) {
    // Nothing to do, exception from `readQuery` means data was not available in cache
  }
}
